// extracted by mini-css-extract-plugin
export var body = "_kh-0";
export var sectionHeader = "_kh-4";
export var shortcutColumns = "_kh-2";
export var shortcutList = "_kh-1";
export var shortcutSection = "_kh-3";